class SubItems extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            items: '.subitems__panel',
            rows: '.subitems__row'
        };
        this.variantSelect = document.querySelector('variant-select') || document.querySelector('variant-radios');
    }

    connectedCallback() {
        this.items = Array.from(this.querySelectorAll(this.selectors.items));
        this.items.forEach(item => {
            item.addEventListener('click', (e) => this.onClick(e))
        });
        this.rows = Array.from(this.querySelectorAll(this.selectors.rows));
        this.onVariantUIUpdate();
    }

    onClick(e) {
        const current = e.currentTarget;
        current.classList.toggle('is-active');
        this.handleErrorMessage();
    }

    getVariants() {
        const actives = this.items.filter(item => item.classList.contains('is-active'));

        if (actives) {
            return [...actives.map(item => JSON.parse(item.nextElementSibling.textContent))];
        } else {
            return null;
        }
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
    }

    onVariantUIUpdate() {
        this.variantSelect.addEventListener('change', () => {
            this.rows.forEach((row) => {
                if (row.dataset.parentVariant == this.variantSelect.currentVariant.id) {
                    row.removeAttribute('hidden');
                } else {
                    row.setAttribute('hidden', true);
                }
            });
            this.items.forEach(item => item.classList.remove('is-active'));
        });
    }
}

customElements.define('sub-items', SubItems);